import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=7ec84854&scoped=true"
import script from "./CommentBlock.vue?vue&type=script&lang=js"
export * from "./CommentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec84854",
  null
  
)

export default component.exports